import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import { Button } from "reactstrap";
import ModalMessage from "../../../shared/components/Modal";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import { useModalAlert } from "../../GeneralComponents";

const renderField = ({
  input,
  disabled,
  placeholder,
  type,
  meta: { touched, error },
  style,
}) => (
  <div
    className="form__form-group-input-wrap form__form-group-input-wrap--error-above"
    style={style}
  >
    <input
      {...input}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
    />
    {touched && error && (
      <span className="form__form-group-error">{error}</span>
    )}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: "",
  meta: null,
  type: "text",
};

const NewPasswordUser = ({ data, openNewPassword, setOpenNewPassword }) => {
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [isPasswordShown2, setIsPasswordShown2] = useState(false);
  const [isPasswordShown3, setIsPasswordShown3] = useState(false);
  const [errors, setErrors] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const { showModalAlert } = useModalAlert();

  const showPassword2 = () => {
    setIsPasswordShown2(!isPasswordShown2);
  };

  const showPassword3 = () => {
    setIsPasswordShown3(!isPasswordShown3);
  };

  const validatePassword = () => {
    let newErrors = {};

    if (!newPassword) newErrors.newpassword = "Ingrese la contraseña nueva";
    else delete newErrors.newpassword;

    if (newPassword.length < 5)
      newErrors.newpassword = "La contraseña debe tener minimo 6 caracteres";
    else delete newErrors.newpassword;

    if (!newPassword2)
      newErrors.newpasswordtwo =
        "Ingrese la contraseña nuevamente la contraseña nueva";
    else delete newErrors.newpasswordtwo;

    if (!(newPassword === newPassword2))
      newErrors.newpasswordtwo = "Las contraseñas nuevas con coinciden";
    else delete newErrors.newpasswordtwo;

    setErrors(newErrors);

    if (!(Object.keys(newErrors).length > 0)) {
      setOpenModal(true);
    }
  };

  const updatePassword = async () => {
    setOpenModal(false);

    const dataSend = { id_usuario: data.id, nueva_password: newPassword };

    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "usuario/cambiar-password-ajena",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        showModalAlert("success", "Se cambio la contraseña correctamente");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <Modal
      open={openNewPassword}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{ zIndex: 1000 }}
    >
      <div
        className="paperAppointment-flex"
        style={{ width: "30%", margin: 5 }}
      >
        <div className="subtitle-mod" style={{ marginBottom: "8px" }}>
          <h4>Cambiar Contraseña </h4>
        </div>
        <h5>Usuario: {data.nombre_usuario}</h5>
        <form className="form" style={{ marginTop: 20 }}>
          <div className="form__form-group">
            <span className="form__form-group-label" style={{ marginTop: 10 }}>
              Contraseña Nueva
            </span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <Field
                name="newpassword"
                component={renderField}
                type={isPasswordShown2 ? "text" : "password"}
                placeholder="Password"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
                meta={{
                  touched: errors.hasOwnProperty("newpassword"),
                  error: errors.hasOwnProperty("newpassword")
                    ? errors.newpassword
                    : "",
                }}
              />
              <button
                className={`form__form-group-button${
                  isPasswordShown2 ? "active" : ""
                }`}
                type="button"
                onClick={showPassword2}
              >
                <EyeIcon />
              </button>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label" style={{ marginTop: 10 }}>
              Repetir Contraseña Nueva
            </span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <Field
                name="newpasswordtwo"
                component={renderField}
                type={isPasswordShown3 ? "text" : "password"}
                placeholder="Password"
                value={newPassword2}
                onChange={(e) => {
                  setNewPassword2(e.target.value);
                }}
                meta={{
                  touched: errors.hasOwnProperty("newpasswordtwo"),
                  error: errors.hasOwnProperty("newpasswordtwo")
                    ? errors.newpasswordtwo
                    : "",
                }}
              />
              <button
                className={`form__form-group-button${
                  isPasswordShown3 ? " active" : ""
                }`}
                type="button"
                onClick={showPassword3}
              >
                <EyeIcon />
              </button>
            </div>
          </div>
        </form>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            style={{ marginTop: 10, marginLeft: 15 }}
            variant="contained"
            onClick={() => {
              setOpenNewPassword(false);
            }}
          >
            Cancelar
          </Button>
          <Button
            style={{ marginTop: 10 }}
            color="primary"
            variant="contained"
            onClick={validatePassword}
          >
            Guardar
          </Button>
        </div>
        <ModalMessage
          color="warning"
          title="¿Estas seguro que deseas cambiar la contraseña de este usuario?"
          message=""
          modal={openModal}
          onOk={updatePassword}
          toggle={() => {
            setOpenModal(false);
          }}
        />
      </div>
    </Modal>
  );
};

export default reduxForm({
  form: "new_pass_form", // a unique identifier for this form
})(NewPasswordUser);
